import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/banner.png';
const _withScopeId = n => (_pushScopeId("data-v-9e113504"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slider"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "slider__inner"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slider-slide__img",
  src: _imports_0,
  alt: "slide"
}, null, -1));
const _hoisted_5 = {
  class: "slider-slide__box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "slider-slide__title"
}, " Ninja Sushi в Киеве! Пока только на левом берегу ", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "slider-slide__text"
}, "Доставку делаем с 10:00 до 19:30", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_swiper, {
    class: "slider-box",
    modules: $setup.modules,
    pagination: {
      clickable: true
    },
    "slides-per-view": 1,
    "space-between": 10
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.slidesCount, item => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: item,
        class: "slider-slide"
      }, {
        default: _withCtx(() => [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createVNode(_component_app_button, {
          class: "slider-slide__btn"
        }, {
          default: _withCtx(() => [_createTextVNode("Перейти к новости")]),
          _: 1
        })])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules"])])])]);
}